import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import _ from 'lodash';

const LOCALE_PREFIX = 'US/components/CTABanner/CTABanner';

export class DefaultGreeting extends Component {
    static propTypes = {
        greeting: PropTypes.node.isRequired
    };

    render() {
        const { greeting } = this.props;

        return (
            <div className="DefaultGreeting">
                <div className="cta-banner hide-for-mobile">
                    <div className="cta-headline">
                        <span className="cta-name">
                            {greeting}
                        </span>
                    </div>
                    <div className="cta-tagline">
                        <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cta-tagline-mobile-greeting`} />
                    </div>
                </div>
            </div>
        );
    }
}

export default DefaultGreeting;
